import { useMutation } from "@tanstack/react-query";
import { confirmAccess, denyAccess } from "../api/access";
import type { ConfirmAccessRequest } from "../api/access";
import { useAppDispatch } from "../store/hooks";
import { setAccess } from "../store/authSlice";

/**
 * React Query mutation за вход в тестов режим (POST /access/confirm-access).
 * При успех обновява Redux state-а с access = true.
 */
export const useConfirmAccess = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: (data: ConfirmAccessRequest) => confirmAccess(data),
    // При успешен отговор — директно обновяваме Redux state-а
    onSuccess: (response) => {
      dispatch(setAccess(response.access));
    },
  });
};

/**
 * React Query mutation за премахване на достъп (POST /access/deny-access).
 * При успех обновява Redux state-а с access = false.
 */
export const useDenyAccess = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: () => denyAccess(),
    // При успешен отговор — директно обновяваме Redux state-а
    onSuccess: (response) => {
      dispatch(setAccess(response.access));
    },
  });
};
